import { useState, useEffect } from 'react'
import { toast } from '@sales-center/components'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { getCompletionDetails } from '../api'
import { IExternalEntityServicesModel } from '../typings'

type State = {
  loading: boolean
  completionDetails: IExternalEntityServicesModel[]
}

export const useGetCompletionDetailsOnMount = (opportunityId: number) => {
  const dispatch = useAppDispatch()

  const [state, setState] = useState<State>(() => ({
    loading: true,
    completionDetails: [],
  }))

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        const result = await dispatch(getCompletionDetails(opportunityId))

        if (mounted) {
          if (getCompletionDetails.fulfilled.match(result)) {
            setState({
              loading: false,
              completionDetails: result.payload.services,
            })
          } else {
            setState({
              loading: false,
              completionDetails: [],
            })
            toast.error('Error loading completion details.')
          }
        }
      } catch {
        if (mounted) {
          setState({
            loading: false,
            completionDetails: [],
          })
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, opportunityId])

  return { ...state }
}
